export default "__VITE_ASSET__iOxvlbmi__"